import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { EstateTaskInstance, FeatureSubscriptionType } from 'queries';

import { canAssignTaskToTrustate } from 'utils/feature-checker';

interface PushToTrustateCellProps extends GridRenderCellParams {
  estateSearchTaskInstances: EstateTaskInstance[];
  estateSearchStatusButton: Function;
  groupedEstateTaskInstancesAsArray: EstateTaskInstance[];
  featureSubscriptionTypeData: { data: FeatureSubscriptionType };
  setShowPlanPaywallModal: (show: boolean) => void;
  setMinimumFeatureSubscriptionType: (type: FeatureSubscriptionType) => void;
  handleAssignClick: (instance: EstateTaskInstance) => void;
  replaceGroupedEstateTaskInstance: (
    group: string,
    oldId: string,
    newInstance: EstateTaskInstance,
  ) => void;
}

export const PushToTrustateCell = ({
  row,
  estateSearchTaskInstances,
  estateSearchStatusButton,
  groupedEstateTaskInstancesAsArray,
  featureSubscriptionTypeData,
  setShowPlanPaywallModal,
  setMinimumFeatureSubscriptionType,
  handleAssignClick,
  replaceGroupedEstateTaskInstance,
}: PushToTrustateCellProps) => {
  const estateTaskInstance = row as EstateTaskInstance;

  const clientEstateTaskInstance =
    estateSearchTaskInstances.find((instance) => instance.id === estateTaskInstance.id) ||
    groupedEstateTaskInstancesAsArray.find((instance) => instance.id === estateTaskInstance.id)!;

  const locked =
    estateTaskInstance.minimumFeatureSubscriptionType &&
    !canAssignTaskToTrustate(
      estateTaskInstance.minimumFeatureSubscriptionType,
      featureSubscriptionTypeData.data,
    );

  return estateSearchStatusButton({
    estateTaskInstance: clientEstateTaskInstance,
    locked,
    onAssignClick: () => {
      if (locked && estateTaskInstance.minimumFeatureSubscriptionType) {
        setShowPlanPaywallModal(true);
        setMinimumFeatureSubscriptionType(estateTaskInstance.minimumFeatureSubscriptionType);
      } else {
        handleAssignClick(clientEstateTaskInstance);
      }
    },
    replaceEstateTaskInstance: (
      oldEstateTaskInstance: EstateTaskInstance,
      newEstateTaskInstance: EstateTaskInstance,
    ) => {
      replaceGroupedEstateTaskInstance(
        oldEstateTaskInstance.group as string,
        oldEstateTaskInstance.id,
        newEstateTaskInstance,
      );
    },
  });
};
